// extracted by mini-css-extract-plugin
export default {"toggle":"Toggle__toggle__EtdvK","medium":"Toggle__medium__SBMgZ","large":"Toggle__large__gQNrj"};